export const NOTIFICATION_ROUTES = {
    LIST: '/notifications',
    CREATE:'/notifications/create',
    DETAIL: '/notifications/$Id'
  } as const;
  